import React, { createContext, useContext, useMemo, useReducer } from 'react';
import { identity } from 'ramda';

export const createLocalContext = ({ reducer, defaultState }) => {
    const Context = createContext({});

    const withLocalProvider = WrappedComponent => (props) => {
        const [state, dispatch] = useReducer(reducer, defaultState);

        const contextValue = useMemo(() => ({
            state,
            dispatch
        }), [state]);

        return (
            <Context.Provider value={contextValue}>
                <WrappedComponent {...props} />
            </Context.Provider>
        );
    };

    const useLocalSelector = (selector = identity) => {
        const { state: stateContext = defaultState } = useContext(Context);

        return selector(stateContext);
    };

    const useLocalDispatch = () => {
        const { dispatch: dispatchContext } = useContext(Context);

        return dispatchContext;
    };

    return {
        withLocalProvider,
        useLocalSelector,
        useLocalDispatch
    };
};
